const getFileDimensions = (file, setInfoMsg) => new Promise((resolve, reject) => {
  if (file.type.includes('pdf')) {
    import(/* webpackChunkName: "pdfjs-main" */ 'pdfjs-dist').then(pdfjs => {
      import(/* webpackChunkName: "pdfjs-worker" */ 'pdfjs-dist/build/pdf.worker.entry').then(worker =>{
        pdfjs.GlobalWorkerOptions.workerSrc = worker

        const fileReader = new FileReader()
        fileReader.onload = () =>
          pdfjs
            .getDocument(fileReader.result)
            .then(pdf => {
              if (pdf.numPages > 1) setInfoMsg('multiPagePdf')
              return pdf.getPage(1).then(page => {
                const viewport = page.getViewport(1)
                resolve({ height: viewport.height, width: viewport.width })
              },
              reject
              )
            })
            .catch(reject)
        fileReader.readAsArrayBuffer(file)
      })
    })
  } else if (file.type.includes('jpg') || file.type.includes('jpeg') || file.type.includes('bmp') || file.type.includes('png')) {
    const _URL = window.URL || window.webkitURL
    const img = new Image()
    img.onload = () => resolve({ height: img.height, width: img.width })
    img.onerror = reject
    img.src = _URL.createObjectURL(file)
  } else {
    resolve({ height: 0, width: 0 })
  }
})

export default getFileDimensions



// WEBPACK FOOTER //
// ./src/components/FloorPlanUploader/getFileDimensions.js